import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import { LogoutOutlined } from "@mui/icons-material";
import { Button } from "../../Buttons";
import { logoutApi } from "../../../api";
import { clearSession } from "../../../utils/session";

export default function FooterSection() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    async function handleLogout() {
        try {
            setLoading(true);
            await logoutApi();
        } catch (error) {
            /* The server-side revoke is best-effort — clear locally either way. */
            console.error("Failed to log out cleanly", { error });
        } finally {
            clearSession();
            setLoading(false);
            navigate("/signin");
        }
    }

    return (
        <Stack>
            <Button
                variant="text"
                color="error"
                startIcon={<LogoutOutlined />}
                sx={{ gap: "12px", justifyContent: "flex-start" }}
                onClick={handleLogout}
                loading={loading}
            >
                Logout
            </Button>
        </Stack>
    );
}
